var tracking_add_to_cart = 1,tracking_cart_buy = 3;
document.querySelector('.template-product').innerHTML = `<div id="cb-upsell"></div>`+document.querySelector('.template-product').innerHTML;
if(document.body.clientWidth >= 768) {
  if(document.querySelector('.mobile-version') !== null) {
    document.querySelector('.mobile-version').remove();
  }
}
else {
  if(document.querySelector('.desktop-version') !== null) {
    document.querySelector('.desktop-version').remove();
  }
}



if(document.querySelector('#ProductSection-product-design-template') != null){
  var myElement = document.querySelector('#ProductSection-product-design-template');
  var btnElement = document.querySelector('#ProductSection-product-design-template').querySelector('#btns_block');
  var breadcrumb = document.querySelector('.breadcrumb');
  var productTitle = document.querySelector('.product-single__titl');
  function inViewport( element ){
    var bb = element.getBoundingClientRect();
    return !(bb.top > innerHeight || bb.bottom < 0);
  }
  
  document.addEventListener( 'scroll', event => {
    if(inViewport( document.querySelector('.site-footer'))) {
      //setTimeout(() => {
      if(document.querySelector('.outer-price-section') !== null){
        document.querySelector('.outer-price-section').classList.add('stuck-price');
      }
      //}, 50)
    }
    else if( !inViewport( btnElement ) && !inViewport( breadcrumb )   ){  
      if(document.querySelector('.outer-price-section') !== null){
        document.querySelector('.outer-price-section').classList.add('open-price');
        document.querySelector('.outer-price-section').classList.remove('stuck-price');
      }
    }                     
    else if( inViewport( myElement ) ){ 
      if(document.querySelector('.outer-price-section') !== null){
        document.querySelector('.outer-price-section').classList.remove('open-price', 'stuck-price');
      }
    } else {
      if(document.querySelector('.outer-price-section') !== null){
        document.querySelector('.outer-price-section').classList.add('open-price');
        document.querySelector('.outer-price-section').classList.remove('stuck-price');
      }
    }
  })
  
  document.addEventListener('DOMContentLoaded', (event) => { 
    if(document.querySelector('.sticky-add-to-cart') !== null){
      document.querySelector('.sticky-add-to-cart').addEventListener('click', function() {
        tracking_add_to_cart = 2;
        if(document.querySelector('button.bold_clone') !== null){
          document.querySelector('button.bold_clone').click();
        }
        else{
          document.querySelector('button[data-add-to-cart]').click();
        }
      })
    }
    if(document.querySelector('.sticky-buy-now') !== null){
      document.querySelector('.sticky-buy-now').addEventListener('click', function() {
        tracking_cart_buy = 4;
        document.querySelector('#buy_btn_id').click();
      }) 
    }
  })
  
  $(document).ready(function() {
    if(document.querySelector('button#buy_btn_id') !== null){
      document.querySelector('button#buy_btn_id').addEventListener('click', function(e){
        e.stopPropagation();

        if(document.querySelector('button.bold_clone') !== null){
          tracking_add_to_cart = tracking_cart_buy;
          document.querySelector('button.bold_clone').click();
        }
        else {
          setProductCartDetails(tracking_cart_buy);
          cartClick(currentProduct.title,currentProduct.id,location.href,tracking_cart_buy);
          this.classList.add('spin_loader_sqr');
          if(document.querySelector('button.sticky-buy-now') !== null){
            document.querySelector('button.sticky-buy-now').classList.add('spin_loader_sqr');
          }

          const productContainer = document.querySelector('#ProductSelect-product-design-template');
          const productId = Number(productContainer.dataset.productid);
          const variantId = Number(productContainer.value);
          const form = document.querySelector('.add_to_cart_frm');

          /*checkHoneyComb(productId,variantId)
          .then(function(res){
            if(typeof res !== 'undefined' && res.hasOwnProperty('_id')){
              addItemToBuy(form)
              .then(
                function(res) {
                  conversionBearUpsell.showFunnel('isProduct');
                  document.querySelector('button#buy_btn_id').classList.remove('spin_loader_sqr');
                   const parent = document.querySelector('.template-product');
                   const element = document.querySelector('#cb-upsell'); 
                   observe(parent,element);
                });
            }
            else {
              addItemToBuy(form)
              .then(
                function(res) {
                  getCheckoutURL();
                }
              );
              checkHoneyApps(productId, variantId)
              .then(function(res){
                if(typeof res !== 'undefined' && res.hasOwnProperty('products')) {
                  if(document.querySelector('button.sticky-buy-now') !== null){
                    document.querySelector('button.sticky-buy-now').classList.remove('spin_loader_sqr');
                  }
                  document.querySelector('[data-add-to-cart]').click();
                  document.querySelector('button#buy_btn_id').classList.remove('spin_loader_sqr');
                }
                else {
                  addItemToBuy(form)
                  .then(
                    function(res) {
                      getCheckoutURL();
                    }
                  );
                }
              });
              
            }
          });    */
          
		
          checkHoneyApps(productId, variantId)
          .then(function(res){
            if(typeof res !== 'undefined' && res.hasOwnProperty('products')) {
              if(document.querySelector('button.sticky-buy-now') !== null){
                document.querySelector('button.sticky-buy-now').classList.remove('spin_loader_sqr');
              }
              document.querySelector('[data-add-to-cart]').click();
              document.querySelector('button#buy_btn_id').classList.remove('spin_loader_sqr');
            }
          });
          
          
          
        } 
        tracking_cart_buy = 3;
      });  
    }
    $('.product-form__cart-submit').click(function(e) {
      var productName = $("meta[property='og:title']").attr("content");
      var productId = currentProduct.id;
      if (productId === sessionStorage.getItem('pageViewedId') && sessionStorage.getItem('pageViewed') && sessionStorage.getItem('pageViewed') === "seen") {
        pagesProductToCart(productId, productName, '1');
      }
      if($(this).attr("aria-label") == 'Add to cart'){
        setProductCartDetails(tracking_add_to_cart);
        cartClick(currentProduct.title,productId,location.href,tracking_add_to_cart);
        tracking_add_to_cart = 1;
      }
    });
  });
}

function pagesProductToCart(pId, pname, qty) {
    var addedAt = $("#currentTime").val();
    var page_source = $("#page_source").val();
    var page_id = $("#page_id").val();

    var response = $.post(theme.remote_url + '/shogun/add-to-cart', {
        quantity: qty,
        productId: pId,
        productname: pname,
        page_source: page_source,
        page_id: page_id,
        added_at: addedAt
      })
      .done(function(res) {
        return res;
      })
      .fail(function(xhr, textStatus, errorThrown) {
        return xhr.statusText;
      });

    return response;
  }

function cartClick(pname, pid, source, button_type) {
  var response = $.post('https://getpump.app/bulbhead/api/cart-click', {
    name: pname,
    id: pid,
    source: source,
    button_type: button_type,
  })
  .done(function(res) {
    return res;
  })
  .fail(function(xhr, textStatus, errorThrown) {
    return xhr.statusText;
  });

  return response;
}

function setProductCartDetails(tracking_cart_buy){
  var cart_tracking_ids = null;
  var  obj = {};
  obj.id = parseInt(currentProduct.id);
  obj.button_type = parseInt(tracking_cart_buy);
  
  if (!sessionStorage.getItem('cart_tracking')) {
    cart_tracking_ids = [];
  } else {
    cart_tracking_ids = JSON.parse(sessionStorage.getItem('cart_tracking'));
  }
  if (cart_tracking_ids.length > 0) {
    var prdetails = cart_tracking_ids.filter(function(out) {
      return (out.id === parseInt(currentProduct.id) && out.button_type === parseInt(tracking_cart_buy));
    });
    if(prdetails.length == 0)
    {
      cart_tracking_ids.push(obj);
      sessionStorage.setItem("cart_tracking", JSON.stringify(cart_tracking_ids));
    }
  }
  else{
  	cart_tracking_ids.push(obj);
    sessionStorage.setItem("cart_tracking", JSON.stringify(cart_tracking_ids));
  }
    
}

async function addItemToBuy(form) {
  let formData = new FormData(form);
  return await fetch(`/cart/add.js`, {
    method: 'POST',
    body: formData
  })
  .then(function(res){
  	return res.json();
  })
  .then(function(res){
    return res;
  })
  .catch(function(err){
  	console.log(err)
  })
}

if(document.querySelector("#myBtn") !== null){
  document.querySelector("#myBtn").addEventListener('click', function(){    
    let videoSrc = document.querySelector('#myModal1 iframe').dataset.src;
    if(videoSrc !== null) {
      document.querySelector('#myModal1 iframe').setAttribute('src', videoSrc)
    }
    document.querySelector("#myModal1").classList.remove('hide');
  });
}

if(document.querySelector("#myModal1") !== null){
  document.querySelector("#myModal1 .close").addEventListener('click', function(){    
    document.querySelector('#myModal1 iframe').setAttribute('src', '');
    document.querySelector("#myModal1").classList.add('hide');

    var urlData = new URL(window.location);  
    if(urlData.searchParams.has('video') === true) {
      urlData.searchParams.delete('video');
      history.pushState('', document.title, window.location.pathname + urlData.search);
    }
  });
}

if($('.wishlist_form').length && sessionStorage.getItem("wishlistArray") !== null){
  if(parseInt(currentProduct.id) === checkItemInWishlist(currentProduct.id)[0]) {
    $('.ws-outline').addClass('visually-hidden');
    $('.ws-solid').removeClass('visually-hidden');               
    $('#wishlist_form').prop('title', 'Item is wishlisted');
  }
}

$('.wishlist_form').on('click', function(e) {
  e.stopImmediatePropagation();
  let id = $(this).attr('id'),
      btn = $(this);

  if (!custId) {
    window.location.href = '/account/login?return_url='+encodeURIComponent(currentProduct.handle);
  } else {
    let product_id = currentProduct.id;        
    btn.addClass('spin_loader');
    $("#" + id).css("pointer-events", "none");
    $.ajax({
      url: 'https://getpump.app/bulbhead/api/wishlist/addto-wishlist',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'POST',
      async: false,
      data: {
        customer_id: custId,
        product_id: product_id,
        customerEmail: customerEmail,
        product_title: currentProduct.title,
        product_price: currentProduct.price,
        product_image: currentProduct.image
      },
      success: function(data) {
        $(".wishnum").text(data.count);
        //$('.wish-loader').addClass('hide');
        btn.removeClass('spin_loader');
        $("#" + id).css("pointer-events", "auto");

        if(data.result === 'added') {
          pushItemtoWishlist(product_id);
          $('.ws-outline').addClass('visually-hidden');
          $('.ws-solid').removeClass('visually-hidden');
          $("#" + id).prop('title', 'Item is wishlisted');
          $("#add-tool").css("visibility", "visible");
          $("#add-tool").css("opacity", "1");
          setTimeout(function() {
            $("#add-tool").css("visibility", "hidden");
          }, 3000);
        }
        else {
          popItemtoWishlist(product_id);
          $('.ws-outline').removeClass('visually-hidden');
          $('.ws-solid').addClass('visually-hidden');
          $("#" + id).prop('title', 'Add to wishlist');
          $("#remove-tool").css("visibility", "visible");
          $("#remove-tool").css("opacity", "1");
          setTimeout(function() {
            $("#remove-tool").css("visibility", "hidden");
          }, 3000);
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
      }
    });
  }
});

window.addEventListener('DOMContentLoaded', function(){
  $(".owl-carousel").owlCarousel({
    items: 4,
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    rewind: true,
    autoplay: false,
    margin: 0,
    nav: true
  });
});

if(document.querySelector(".highlight-link") !== null){
  document.querySelector(".highlight-link").addEventListener('click', function() {
    $('html,body').animate({scrollTop: $("#shopify-section-short-description").offset().top-100}, 'slow');
  });
}


/**HoneyComp Upsell Custom Code**/
async function checkHoneyComb(productId,variantId){  
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
	
  const jsonData = JSON.stringify({
    "product_ids": [
      productId
    ],
    "variant_ids": [
      variantId
    ],
    "current_product": [
      productId
    ],
    "current_variant": variantId,
    "page_to_show": "product_page"
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: jsonData,
    redirect: 'follow'
  };
  

  return await fetch("https://upsell.conversionbear.com/default/campaign_page?shop=bulbheadstore2.myshopify.com&isMobile=false&currency=USD", requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error));
}

// $('body').on("DOMSubtreeModified", function(e){ 
// //$(document).on('click', '.WidgetContainer__Bg-y58ku8-0', function(){
// 	console.log(e)
// })
/** End **/


/** Cross Sell App Script ***
if(document.querySelector('#cross-sale') !== null) {
  document.querySelector('#cross-sale').addEventListener('click', function(e){
    e.stopPropagation();
    $('#cross-sale').addClass('spin_loader_sqr');  
    addItemToBuy()
    .then(function(res){    
  //     $('#cross-sale').removeClass('spin_loader_sqr');  
      let productIds = [];
      if(typeof xsellSettings.product_crosssells !== 'undefined' || xsellSettings.product_crosssells !== null) {
        let crSellProducts = xsellSettings.product_crosssells;
        crSellProducts.forEach(function(item){
          productIds.push(item.id);
        });
      }

      if(productIds.length) {
        $.getJSON('/cart.js').then(
          function(cart) {
            let cartItems = cart.items;
            cartItems.forEach(function(item){            
              if($.inArray( item.product_id , productIds ) !== -1) {
                console.log('sss')
                return getCheckoutURL();
              }
            });
          }
        );
      }

    }); 
  });
}


/**
* Trigger when cross sell popup will be closed without clicking Close Icon
*
let crossSell = true;
$(document).on('DOMSubtreeModified', '#xsell-app--upsell', function(){
  if(crossSell) {
   getCheckoutURL();
   crossSell = false;
  }  
});

/**
* Trigger when cross sell popup will be closed using Close Icon / Skip option
*
$(document).on('click', '.xsell__modal-close, .xsell__modal-skip', function(){
  getCheckoutURL();
});
*/

function observe(parent,element){
  const obs = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const el of mutation.removedNodes) {
        if (el === element) {
          getCheckoutURL();
          obs.disconnect();
        }
      }
    }
  });
  obs.observe(parent, {
    childList: true,
  });
}

if(document.querySelector('.shogun_buy') != null){
  document.querySelectorAll('.shogun_buy').forEach((el,index) => { 
    el.addEventListener('click', function(e){
      el.classList.add('spin_loader_sqr');
      document.querySelectorAll('.shogun_buy').forEach((bu) => { 
        bu.style.pointerEvents = "none";
      });
      var  originProductId  = Number(document.querySelectorAll('.product_cart_form #p_id')[index].value);
      var  originVariantId = Number(document.querySelectorAll('.product_cart_form select')[index].value);
      var  form = document.querySelectorAll('.product_cart_form')[index];
      addItemToBuy(form)
      .then(function(response){
        sessionStorage.setItem('order_source', 'product_option');
        checkHoneyComb(originProductId,originVariantId)
        .then(function(res){
          if(typeof res !== 'undefined' && res.hasOwnProperty('_id')){
            conversionBearUpsell.showFunnel('isProduct',{ originVariantId, originProductId });
            el.classList.remove('spin_loader_sqr');
            const parent = document.querySelector('.template-product');
            const element = document.querySelector('#cb-upsell'); 
            observe(parent,element);
          }
          else{
            getCheckoutURL();
          }
        });
      });
    });
  });
}
//-----------------------

/**
* Check Honey App Upsell
*/
async function checkHoneyApps(productId, variantId){
  return await fetch(`https://app.honeyapps.co/api/front/offers?domain=bulbheads.myshopify.com&product_id=${productId}&variants_id=${variantId}&cart=5337879543852&trigger_event=1&display_on_device=3&cart_value=6993&logged_user=0`)
  .then(response => response.json())
  .then(result => result)
  .catch(error => console.log('error', error));
}